import { Phone, Clock, Mail, MapPin } from "lucide-react";
import { business } from "@/lib/business-data";

const TopBar = () => {
  return (
    <div className="hidden sm:block section-dark text-white">
      <div className="container-max flex items-center justify-between px-4 py-2 text-xs lg:text-[13px] gap-4">
        <div className="flex items-center gap-5 min-w-0">
          <a
            href={business.emailHref}
            className="flex items-center gap-2 text-white/90 hover:text-white transition-colors truncate"
          >
            <Mail className="h-3.5 w-3.5 shrink-0" style={{ color: "hsl(var(--primary-on-dark))" }} />
            <span className="truncate">{business.email}</span>
          </a>
          <div className="hidden lg:flex items-center gap-2 text-white/90">
            <MapPin className="h-3.5 w-3.5 shrink-0" style={{ color: "hsl(var(--primary-on-dark))" }} />
            <span>{business.address.full}</span>
          </div>
        </div>
        <div className="flex items-center gap-5 shrink-0">
          <div className="hidden md:flex items-center gap-2 text-white/90">
            <Clock className="h-3.5 w-3.5 shrink-0" style={{ color: "hsl(var(--primary-on-dark))" }} />
            <span>
              {business.hours.label} · {business.hours.time}
            </span>
          </div>
          <a
            href={business.phoneHref}
            className="flex items-center gap-2 font-bold text-white hover:opacity-80 transition-opacity"
          >
            <Phone className="h-3.5 w-3.5 shrink-0" style={{ color: "hsl(var(--secondary-on-dark))" }} />
            <span>{business.phone}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
